// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powerbi-frame--dotted {
  border: 2px dashed #cecece;
}

.powerbi-frame {
  height: 100%;
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  flex-direction: column;
  padding-right: 1px;
  padding-left: 1px;
  padding-top: 74px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}

.powerbi-frame iframe {
  border: none;
}

.bookmarks-open {
  left: 251px !important;
}

.bookmarks-closed {
  width: 29px;
}

.powerbi-wrapper {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  border: 1px solid gray;
  margin-left: 1px;
  margin-right: 1px;
  box-sizing: border-box;
}

.powerbi-wrapper-personal-bookmarks {
  /* position: absolute;
  bottom: 0px;
  top: 107px;
  right: 0px;
  left: 30px; */
  width: 100%;
}

.powerbi-tools-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding-bottom: 4px;
  padding-right: 14px;
  margin-top: 6px;
}

.powerbi-tools {
  cursor: pointer;
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  user-select: none;
}
.powerbi-tool-menu {
  cursor: pointer;
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  user-select: none;
}

.powerbi-tools svg,
.powerbi-tool-menu svg {
  display: block;
}

svg:hover {
  fill: black;
}

.landing-section-title {
  font-size: 16px;
  font-weight: 500;
  color: rgb(112, 112, 112);
  margin-left: 8px;
  /* margin-bottom: 8px; */
}

.landing-folder-icon {
  display: flex;
  cursor: pointer;
}

.landing-ws-title {
  font-size: 18px;
  font-weight: 500;
  color: rgb(112, 112, 112);
  margin-left: 8px;
  /* margin-bottom: 4px; */
  width: fit-content;
  cursor: pointer;
}

.description-text {
  font-size: 15px;
  color: #707070;
  margin-left: 8px;
}

.ws-app-section {
  display: flex;
  flex-direction: row;
  margin-left: 27px;
  margin-bottom: 10px;
}

.ta-dashboard-reports {
  min-height: 40%;
  display: flex;
  /* flex-direction: column; */
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/powerBI/components/report/style/style.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;;;;eAIa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":[".powerbi-frame--dotted {\n  border: 2px dashed #cecece;\n}\n\n.powerbi-frame {\n  height: 100%;\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  flex-direction: column;\n  padding-right: 1px;\n  padding-left: 1px;\n  padding-top: 74px;\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.powerbi-frame iframe {\n  border: none;\n}\n\n.bookmarks-open {\n  left: 251px !important;\n}\n\n.bookmarks-closed {\n  width: 29px;\n}\n\n.powerbi-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  border: 1px solid gray;\n  margin-left: 1px;\n  margin-right: 1px;\n  box-sizing: border-box;\n}\n\n.powerbi-wrapper-personal-bookmarks {\n  /* position: absolute;\n  bottom: 0px;\n  top: 107px;\n  right: 0px;\n  left: 30px; */\n  width: 100%;\n}\n\n.powerbi-tools-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 4px;\n  padding-right: 14px;\n  margin-top: 6px;\n}\n\n.powerbi-tools {\n  cursor: pointer;\n  margin-left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: manipulation;\n  -ms-touch-action: manipulation;\n  user-select: none;\n}\n.powerbi-tool-menu {\n  cursor: pointer;\n  margin-left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: manipulation;\n  -ms-touch-action: manipulation;\n  user-select: none;\n}\n\n.powerbi-tools svg,\n.powerbi-tool-menu svg {\n  display: block;\n}\n\nsvg:hover {\n  fill: black;\n}\n\n.landing-section-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: rgb(112, 112, 112);\n  margin-left: 8px;\n  /* margin-bottom: 8px; */\n}\n\n.landing-folder-icon {\n  display: flex;\n  cursor: pointer;\n}\n\n.landing-ws-title {\n  font-size: 18px;\n  font-weight: 500;\n  color: rgb(112, 112, 112);\n  margin-left: 8px;\n  /* margin-bottom: 4px; */\n  width: fit-content;\n  cursor: pointer;\n}\n\n.description-text {\n  font-size: 15px;\n  color: #707070;\n  margin-left: 8px;\n}\n\n.ws-app-section {\n  display: flex;\n  flex-direction: row;\n  margin-left: 27px;\n  margin-bottom: 10px;\n}\n\n.ta-dashboard-reports {\n  min-height: 40%;\n  display: flex;\n  /* flex-direction: column; */\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
